import TemplateNames from './TemplateNames';

export default {
  title: 'Automatyczne e-maile',
  labels: {
    empty_list: 'Nie znaleziono szablonów',
    load_failed:
      'Nie udało się załadować Twoich automatycznych e-maili. Odśwież stronę lub skontaktuj się z pomocą techniczną.',
    on: 'Wł.',
    off: 'Wył.',
  },
  fields: {
    name: 'Nazwa',
    messages_delivered: 'Dostarczone wiadomości',
    open_rate: 'Wskaźnik otwarć',
    click_rate: 'Wskaźnik kliknięć',
    status: 'Status',
  },
  template_names: TemplateNames,
  toasts: {
    failed_to_update_status: 'Nie udało się zaktualizować statusu',
    failed_to_load_data: 'Nie udało się załadować danych',
  },
};
